import React, { useMemo, useState } from "react";
import { Grid } from "@material-ui/core"; import CustomTypo from "./CustomTypo";
import { CustomizedCircularProgressLight } from "./CircularProgress";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/styles";
import DrawerCustom from './DrawerCustom';
import ButtonCustom from "./ButtonCustom";
import {
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import './formStripe.css';
import crmservices from "../wsclient/crmservices";
import { connection } from "../../portal.config";
import ModalAlert from "./ModalAlert";
import { ErrorIcon, SuccessIcon } from "./icons";


const styles = theme => ({
    container: {
        marginTop: theme.spacing(8),
        backgroundColor: theme.palette.background.secondary,
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2)
    },
});

const useOptions = () => {
    const options = useMemo(
        () => ({
            style: {
                base: {
                    color: "#424770",
                    letterSpacing: "0.025em",
                    fontFamily: "Source Code Pro, monospace",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "#9e2146"
                }
            }
        }),
    );

    return options;
};

//card info test
//4242 4242 4242 4242
//12/34
//123

function FormStripe(props) {
    const { t, classes } = props;
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [stripeResult, setStripeResult] = useState(null);
    const options = useOptions();
    const stripe = useStripe();
    const elements = useElements();

    const addPaymentMethod = async (event) => {
        onShowLoading(true);
        try {
            event.preventDefault();
            if (!stripe || !elements) {
                return;
            }
            const payload = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardNumberElement)
            });
            console.log("[PaymentMethod]", payload);
            let cardInfo = payload && payload.paymentMethod && payload.paymentMethod.card ? payload.paymentMethod.card : null;

            let stripeIntegration = connection.crmConfig.stripeIntegration;
            let result = await crmservices.paymentgateway.addPaymentMethod({
                name: "STRIPE",
                payment_method_type: "CARD",
                gateway: "STRIPE",
                integration_id: stripeIntegration,
                payment_method_nonce_token: payload && payload.paymentMethod && payload && payload.paymentMethod.id ? payload && payload.paymentMethod.id : null,
                card_info: {
                    name: 'Default Card',
                    brand: cardInfo && cardInfo.brand ? cardInfo.brand.toUpperCase() : null,
                    first6: cardInfo && cardInfo.first6 ? cardInfo.first6 : null,
                    last4: cardInfo && cardInfo.last4 ? cardInfo.last4 : null,
                    expiration_month: cardInfo && cardInfo.exp_month ? cardInfo.exp_month : null,
                    expiration_year: cardInfo && cardInfo.exp_year ? cardInfo.exp_year : null,
                },
            });
            if (result.code == 'OK') {
                setStripeResult('success');
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'))
                setStripeResult('error');
            }
        }
        catch (ex) {
            showMessage(true, t('EXCEPTION_PROCESS'));
            console.log("exception addPaymentMethod===", ex);
        }
        onShowLoading(false);
    }

    const showMessage = async (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    return (
        <DrawerCustom
            open={props.open}
            onClose={() => {props.onClose(); props.onRefresh(); props.setOpen({my_cards_orders: true})}}
            title={t('Your Stripe')}
            enableBack
        >
            {!stripeResult ? <Grid item container justify='center' className={classes.container}>
                <Grid item xs={12}>
                    <CustomTypo mg_left_sm variant='caption1' color='onPrimary'>{'Your Stripe'}</CustomTypo>
                </Grid>
                <Grid item xs={12}>
                    {showLoading && <CustomizedCircularProgressLight />}
                </Grid>
                <Grid item xs={12}>
                    <form onSubmit={addPaymentMethod} className="form-stripe">
                        <label>
                            Card number
                            <CardNumberElement
                                options={options}
                                onReady={() => {
                                    // console.log("CardNumberElement [ready]");
                                }}
                                onChange={event => {
                                    // console.log("CardNumberElement [change]", event);
                                }}
                                onBlur={() => {
                                    // console.log("CardNumberElement [blur]");
                                }}
                                onFocus={() => {
                                    // console.log("CardNumberElement [focus]");
                                }}
                            />
                        </label>
                        <label>
                            Expiration date
                            <CardExpiryElement
                                options={options}
                                onReady={() => {
                                    // console.log("CardNumberElement [ready]");
                                }}
                                onChange={event => {
                                    // console.log("CardNumberElement [change]", event);
                                }}
                                onBlur={() => {
                                    // console.log("CardNumberElement [blur]");
                                }}
                                onFocus={() => {
                                    // console.log("CardNumberElement [focus]");
                                }}
                            />
                        </label>
                        <label>
                            CVC
                            <CardCvcElement
                                options={options}
                                onReady={() => {
                                    // console.log("CardNumberElement [ready]");
                                }}
                                onChange={event => {
                                    // console.log("CardNumberElement [change]", event);
                                }}
                                onBlur={() => {
                                    // console.log("CardNumberElement [blur]");
                                }}
                                onFocus={() => {
                                    // console.log("CardNumberElement [focus]");
                                }}
                            />
                        </label>
                        <button type="submit">
                            Pay
                        </button>
                    </form>
                </Grid>
            </Grid> :
                <Grid xs={12} item>
                    <Grid xs={12} item justify='center' container>
                        {stripeResult == 'success' && <SuccessIcon style={{ width: 100, height: 100 }} />}
                        {stripeResult == 'error' && <ErrorIcon style={{ width: 100, height: 100 }} />}
                    </Grid>
                    <Grid xs={12} item justify='center' container>
                        {stripeResult == 'success' && <CustomTypo color="onPrimary" variant="subtitle1" mg_top_xl>{t("Add payment method successfully")}</CustomTypo>}
                        {stripeResult == 'error' && <CustomTypo color="onPrimary" variant="subtitle1" mg_top_xl>{t('Add payment method failed')}</CustomTypo>}
                    </Grid>
                </Grid>}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
        </DrawerCustom>
    );
}

export default withStyles(styles)(withTranslation()(FormStripe));